import { APIServiceError } from 'frontcore/data/api-service/service-error/errors/service-error'

export class AuthenticationServiceError<SD = unknown> extends APIServiceError<SD> {}

type PasswordExpiredErrorServiceDetail = { user_id: number }
export class PasswordExpiredError extends AuthenticationServiceError<PasswordExpiredErrorServiceDetail> {
  get userId (): number | undefined {
    return this.response?.data.service_detail.user_id
  }
}

export class TokenExpiredServiceError extends AuthenticationServiceError {}
export class PasswordResetLinkAlreadyUsedServiceError extends AuthenticationServiceError {}
export class PasswordResetLinkExpiredServiceError extends AuthenticationServiceError {}
export class PasswordResetLinkInvalidServiceError extends AuthenticationServiceError {}
